export const getQueryParam = (search: string, param: string): string | null => {
  const params = new URLSearchParams(search);
  return params.get(param);
};

export const withCacheBuster = (url?: string): string | undefined => {
  if (!url) {
    return undefined;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}time=${Date.now()}`;
};
